const FormatStandardDate = (dateStr) => {
  // Accepts 'yyyyMMdd' or 'YYYY-MM-DD'
  let dateObj;
  if (!dateStr) return '';
  if (dateStr.length === 8 && !dateStr.includes('-')) {
    // Convert 'yyyyMMdd' to 'YYYY-MM-DD'
    dateStr = `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
  }
  dateObj = new Date(dateStr);
  if (isNaN(dateObj.getTime())) return dateStr;
  const mm = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getUTCDate()).padStart(2, '0');
  const yyyy = dateObj.getUTCFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

export default FormatStandardDate;